import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../shared/services/dashboard/dashboard.service';
import {
  DashboardData,
  DashboardPeriodOption,
  EngagementDonutMetric,
  ProgressMetric,
  RankingItem,
} from '../../shared/models/interfaces/dashboard/dashboard.interface';
import { DashboardMetricsGridComponent } from './components/dashboard-metrics-grid/dashboard-metrics-grid.component';
import { DashboardSectionHeaderComponent } from './components/dashboard-section-header/dashboard-section-header.component';
import { DashboardDonutMetricCardComponent } from './components/dashboard-donut-metric-card/dashboard-donut-metric-card.component';
import { DashboardProgressMetricComponent } from './components/dashboard-progress-metric/dashboard-progress-metric.component';
import { DashboardGaugeChartComponent } from './components/dashboard-gauge-chart/dashboard-gauge-chart.component';
import { DashboardRankingListComponent } from './components/dashboard-ranking-list/dashboard-ranking-list.component';
import { DashboardTimeMetricCardComponent } from './components/dashboard-time-metric-card/dashboard-time-metric-card.component';
import { DashboardCounterMetricCardComponent } from './components/dashboard-counter-metric-card/dashboard-counter-metric-card.component';

@Component({
  selector: 'l-dashboard',
  imports: [
    DashboardMetricsGridComponent,
    DashboardSectionHeaderComponent,
    DashboardDonutMetricCardComponent,
    DashboardProgressMetricComponent,
    DashboardGaugeChartComponent,
    DashboardRankingListComponent,
    DashboardTimeMetricCardComponent,
    DashboardCounterMetricCardComponent,
  ],
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit {

  constructor(
    private readonly dashboardService: DashboardService,
  ) {}

  public dashboardData!: DashboardData;

  public periodOptions: DashboardPeriodOption[] = [];

  public engagementDonuts: EngagementDonutMetric[] = [];

  public engagementProgress: ProgressMetric[] = [];

  public mostWatchedLessons: RankingItem[] = [];

  public mostAccessedCourses: RankingItem[] = [];

  public highestCompletionCourses: RankingItem[] = [];

  public lessonsPeriod: string = '2026-year';

  public coursesAccessPeriod: string = '2026-01';

  public coursesCompletionPeriod: string = '2026-01';

  public ngOnInit(): void {
    this.dashboardData = this.dashboardService.getDashboardData();
    this.periodOptions = this.dashboardService.getPeriodOptions();
    this.refreshEngagementData();
    this.refreshRankingsData();
  }

  public onLessonsPeriodChange(period: string): void {
    this.lessonsPeriod = period;
    this.mostWatchedLessons = this.dashboardService.getMostWatchedLessons(period);
  }

  public onCoursesAccessPeriodChange(period: string): void {
    this.coursesAccessPeriod = period;
    this.mostAccessedCourses = this.dashboardService.getMostAccessedCourses(period);
  }

  public onCoursesCompletionPeriodChange(period: string): void {
    this.coursesCompletionPeriod = period;
    this.highestCompletionCourses = this.dashboardService.getHighestCompletionCourses(period);
  }

  private refreshEngagementData(): void {
    this.engagementDonuts = this.dashboardService.getEngagementDonuts('2026-02');
    this.engagementProgress = this.dashboardService.getEngagementProgress('2026-02');
  }

  private refreshRankingsData(): void {
    this.mostWatchedLessons = this.dashboardService.getMostWatchedLessons(this.lessonsPeriod);
    this.mostAccessedCourses = this.dashboardService.getMostAccessedCourses(this.coursesAccessPeriod);
    this.highestCompletionCourses = this.dashboardService.getHighestCompletionCourses(this.coursesCompletionPeriod);
  }

}
